import React from 'react';
import { SponsorshipCard } from './SponsorshipCard';
import { SponsorshipPersonCard } from './SponsorshipPersonCard';

type Person = {
  name: string;
  title: string;
  initials?: string;
};

type Props = {
  description: string;
  contact: Person;
};

export function TargetProfileCard({ description, contact }: Props) {
  return (
    <SponsorshipCard>
      <SponsorshipPersonCard
        name={contact.name}
        title={contact.title}
        initials={contact.initials}
        align="left"
        topComment={description}
      />
    </SponsorshipCard>
  );
}
